import { Map as ImMap, isRecord } from 'immutable';

import {
  createTypedQcsSyncResourceStoreFactory,
  type QcsSyncResourceStore,
} from 'app-components/flux/core/resourceStoreTypes';
import { defaultCacheToState } from 'app-components/utils/persist/getCachedState';

import {
  mkReportConfiguration,
  type ReportConfigurationInputProps,
  type ReportConfigurationProps,
} from './reportConfigurationsTypes';

const ReportConfigurationStore = createTypedQcsSyncResourceStoreFactory<ReportConfigurationProps>();

/** Restores cached report configurations while canonicalizing deprecated date-range IDs. */
export const cacheToStateReportConfigurations = (
  cachedState: unknown,
): QcsSyncResourceStore<ReportConfigurationProps> => {
  const state = defaultCacheToState(cachedState) as QcsSyncResourceStore<ReportConfigurationInputProps>;
  if (!isRecord(state)) {
    throw new TypeError('Cached report configuration state must be an Immutable Record');
  }

  const { resourcesById } = state;
  if (!ImMap.isMap(resourcesById)) {
    throw new TypeError('Cached report configuration resources must be an Immutable Map');
  }

  return ReportConfigurationStore({
    resourcesById: resourcesById.map((resource) => {
      if (!isRecord(resource)) {
        throw new TypeError('Cached report configurations must be Immutable Records');
      }
      return mkReportConfiguration(resource.toJS() as ReportConfigurationInputProps);
    }),
    resourceName: state.resourceName,
    lastSyncDate: state.lastSyncDate,
    loadPending: state.loadPending,
    isLoading: state.isLoading,
    error: state.error,
  });
};
